import * as React from 'react';

import { useChatPageMessages } from './hooks/useChatPageMessages';
import { useMergeOfferMessages } from './hooks/useMergeOfferMessages';
import { ChatPageLayout } from '../../components/ChatPageLayout';
import { ChatPrettyDate } from '../../components/ChatPrettyDate';
import { TMessage, IMessagePage } from '../../types/messages';
import { useRuntimeSetting } from '../../hooks/useRuntimeSetting';

type TProps = {
  page: IMessagePage;
  setRefInMessagesMap: (r: HTMLDivElement | null, message: TMessage, messageId: string) => void;
  unreadRef: React.RefObject<HTMLDivElement | null>;
};

export const ChatPageContainer: React.FC<TProps> = ({ page, setRefInMessagesMap, unreadRef }) => {
  const isHorizontalGalleryOffersViewEnabled = useRuntimeSetting<boolean>(
    'frontend-chats.horizontalGalleryOffers.Enabled',
    false,
  );

  const { date, messages } = page;

  const { mergedMessages: mergedFromHook } = useMergeOfferMessages(messages);
  const mergedMessages = isHorizontalGalleryOffersViewEnabled ? mergedFromHook : messages;

  const { messagesNode } = useChatPageMessages(mergedMessages, setRefInMessagesMap, unreadRef);

  return <ChatPageLayout key={`chat_page_${date}`} date={<ChatPrettyDate date={date} />} messages={messagesNode} />;
};
